// The legal footer (DESIGN-BRIEF §2 + Landing.dc.html, verbatim, every page).
import Wordmark from '@/components/Wordmark.jsx';

const LINKS = ['Privacy Policy', 'Terms of Use', 'Accessibility Statement', 'Licenses', 'Do Not Sell or Share My Personal Information'];

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-line bg-white">
      <div className="mx-auto flex max-w-[1240px] flex-wrap items-start justify-between gap-8 px-6 pb-11 pt-9 lg:px-14">
        <Wordmark className="text-base text-primary" />
        <div className="max-w-[660px] text-xs leading-[1.65] text-ink-faint">
          clearedto.rent is a service of NDEMNIFLY Aviation Insurance, CA License #6018700.
          Coverage (&quot;Personal and/or CFI Non-Owned aircraft liability coverage&quot;) is underwritten by Global
          Aerospace and bound only upon carrier acceptance and payment. Premiums are collected by the carrier.
          Certificate delivery and dashboard services are provided at no charge to flight schools.
          clearedto.rent does not pay flight schools for the sale of insurance.
          <div className="mt-3 flex flex-wrap gap-4 text-xs font-semibold">
            {LINKS.map((l) => <a key={l} href="#">{l}</a>)}
          </div>
        </div>
      </div>
    </footer>
  );
}
